// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"rE-z","cltLink":"sE-z","shippingDisclaimer":"tE-z"};